/*
  Travel Pack shop section (sections/main-product-travel-pack-v1.liquid)

  The scent row (> 5 scents) is a native scroll row now — snippets/
  kl-scroll-row-assets + assets/kl-scroll-row.js, shared with the DS v1 PDP —
  so there is no slider code here any more (replaced Swiper 2026-10-07).
  Variant selection, prices, ATC / Buy Now, drawers and accordions are
  handled by the shared theme.js / custom.js code.
*/

/*
  Rebuy "Pairs Perfectly With" widget inside the travel pack section.

  Travel scents are separate products, so the DS widget logic in custom.js
  (which matches the PDP's selected variant option1) can't be reused. Here the
  pairing key is the page's scent (data-tp-scent on the section root):

    Scented pages   -> the Rebuy card whose variant option1 equals the scent
                       (e.g. "Ocean Breeze / 5 Packs")
    Fragrance Free, -> the fallback product (data-tp-rebuy-fallback, section
    or paired item     setting, default: Vegan Stain Remover Bar travel size)
    out of stock

  The paired card goes first; every other in-stock card follows.
  Stock is market-aware, same as DS: /products/<handle>?view=rebuy-inventory
  (location_inventory) plus the theme's force-sold-out SKUs.

  Works for whichever Rebuy widget id is placed in this section, so swapping
  the widget in the theme editor needs no code change.
*/
(function () {
  var section = document.querySelector('.tp-section[data-tp-scent]');
  if (!section) return;
  var holder = section.querySelector('[data-rebuy-id]');
  if (!holder || section.__tpRebuyInit) return;
  section.__tpRebuyInit = true;

  var widgetId = String(holder.getAttribute('data-rebuy-id'));

  // Rebuy replaces the [data-rebuy-id] div with its own element (copying its attributes),
  // so never keep a reference to it — always look up the live one(s).
  function holders() {
    return Array.prototype.slice.call(section.querySelectorAll('[data-rebuy-id="' + widgetId + '"]'));
  }
  var scent = (section.getAttribute('data-tp-scent') || '').trim().toLowerCase();
  var fallbackHandle = (section.getAttribute('data-tp-rebuy-fallback') || '').trim().toLowerCase();

  var pathParts = window.location.pathname.split('/').filter(Boolean);
  var marketPrefix = pathParts.length && /^[a-z]{2}-[a-z]{2,}$/i.test(pathParts[0]) ? '/' + pathParts[0] : '';

  var stockByVariant = {};   // variant id -> market stock level
  var inventoryRequests = {}; // handle -> Promise
  var inventoryLoaded = {};   // handle -> true once its stock has arrived
  var revealed = false;
  var safetyTimer = null;

  // Hide until the cards are sorted (set from JS so the widget still shows if this script fails).
  // If Rebuy somehow rendered first, leave it visible rather than risk hiding it.
  if (holder.children.length === 0) holder.classList.add('tp-rebuy-pending');

  function reveal() {
    if (safetyTimer) { clearTimeout(safetyTimer); safetyTimer = null; }
    revealed = true;
    holders().forEach(function (el) { el.classList.remove('tp-rebuy-pending'); });
  }

  // Safety net: if Rebuy renders without our event ever firing, show it anyway.
  if (window.MutationObserver) {
    var observer = new MutationObserver(function () {
      observer.disconnect();
      if (!revealed && !safetyTimer) safetyTimer = setTimeout(reveal, 3000);
    });
    observer.observe(holder.parentNode || section, { childList: true, subtree: true });
  }

  function forcedSoldOutSkus() {
    var list = Array.isArray(window.forceSoldOutSkus) ? window.forceSoldOutSkus : [];
    return list.map(function (s) { return String(s).trim(); }).filter(Boolean);
  }

  function loadInventory(handle) {
    if (!handle) return Promise.resolve();
    if (!inventoryRequests[handle]) {
      // No JSON Accept header: that would make Shopify skip the Liquid view.
      inventoryRequests[handle] = fetch(marketPrefix + '/products/' + encodeURIComponent(handle) + '?view=rebuy-inventory')
        .then(function (res) { return res.ok ? res.text() : ''; })
        .then(function (text) {
          inventoryLoaded[handle] = true;
          var data = JSON.parse(text);
          (data.variants || []).forEach(function (v) {
            if (typeof v.stock_level === 'number') stockByVariant[String(v.id)] = v.stock_level;
          });
        })
        .catch(function () {});
    }
    return inventoryRequests[handle];
  }

  function isInStock(variant, forced) {
    if (!variant) return false;
    if (variant.sku && forced.indexOf(String(variant.sku).trim()) !== -1) return false;
    var stock = stockByVariant[String(variant.id)];
    if (typeof stock === 'number') return stock > 0;
    return variant.available !== false;
  }

  function orderCards(cards) {
    var forced = forcedSoldOutSkus();
    var inStock = [];

    cards.forEach(function (card) {
      var variants = (card && card.variants) || [];
      var available = variants.filter(function (v) { return isInStock(v, forced); });
      if (!available.length) return;
      inStock.push(available.length === variants.length ? card : Object.assign({}, card, { variants: available }));
    });

    var paired = null;
    if (scent) {
      paired = inStock.filter(function (card) {
        return card.variants.some(function (v) { return String(v.option1 || '').trim().toLowerCase() === scent; });
      })[0] || null;
    }
    if (!paired && fallbackHandle) {
      paired = inStock.filter(function (card) { return String(card.handle || '').toLowerCase() === fallbackHandle; })[0] || null;
    }

    return paired ? [paired].concat(inStock.filter(function (card) { return card !== paired; })) : inStock;
  }

  function apply(widget, originalCards, keepHidden) {
    var ordered = orderCards(originalCards);
    var list = widget.data.products;

    widget.__tpSorting = true;
    list.splice.apply(list, [0, list.length].concat(ordered));
    widget.__tpSorting = false;


    // Let Vue re-render, then resync Rebuy's Flickity carousel so there are no blank slides.
    setTimeout(function () {
      var carousel = widget.View && widget.View.carousel;
      if (carousel) {
        if (typeof carousel.reloadCells === 'function') carousel.reloadCells();
        if (typeof carousel.resize === 'function') carousel.resize();
        if (typeof carousel.select === 'function') carousel.select(0, false, true);
      }
      if (keepHidden) return;
      // Nothing in stock to recommend: drop the empty "Pairs Perfectly With" box.
      holders().forEach(function (el) { el.hidden = ordered.length === 0; });
      reveal();
    }, 200);
  }

  document.addEventListener('rebuy.productsChange', function (event) {
    var widget = event.detail && event.detail.widget;
    if (!widget || String(widget.id) !== widgetId || widget.__tpSorting) return;
    if (!widget.data || !Array.isArray(widget.data.products)) return;

    var originalCards = widget.data.products.slice();
    var handles = [];
    originalCards.forEach(function (card) {
      if (card && card.handle && handles.indexOf(card.handle) === -1) handles.push(card.handle);
    });

    if (safetyTimer) clearTimeout(safetyTimer);
    safetyTimer = setTimeout(reveal, 3000);

    // Pass 1 (instant): Shopify availability + force-sold-out SKUs, so the paired
    // card is already first. Pass 2 (below) re-sorts with market stock and reveals.
    var allLoaded = handles.every(function (h) { return inventoryLoaded[h]; });
    if (!allLoaded) {
      try { apply(widget, originalCards, true); } catch (e) {}
    }

    Promise.all(handles.map(loadInventory)).then(function () {
      try {
        apply(widget, originalCards);
      } catch (e) {
        reveal();
      }
    });
  });
})();
